import React, { useContext } from 'react';
import { Alert } from 'react-bootstrap';
import { CheckCircle, AlertCircle, Info } from 'lucide-react';
import AppContext from '../../../context/AppContext';

const DestinationToast = () => {
  const { destinationToast, hideDestinationToast } = useContext(AppContext);

  if (!destinationToast.show) return null;

  const icons = {
    success: <CheckCircle className="adm-dest-toast-icon" />,
    error: <AlertCircle className="adm-dest-toast-icon" />,
    info: <Info className="adm-dest-toast-icon" />
  };

  const variant = {
    success: 'success',
    error: 'danger',
    info: 'info'
  }[destinationToast.type] || 'info';

  return (
    <Alert 
      variant={variant} 
      className="adm-dest-toast-alert"
      onClose={hideDestinationToast}
      dismissible
    >
      <div className="d-flex align-items-center">
        {icons[destinationToast.type]}
        <span className="adm-dest-toast-message ms-2">{destinationToast.message}</span>
      </div>
    </Alert>
  );
};

export default DestinationToast;